import { formatPrice } from "apps/visits/core/utils/format-price";
import { useTranslation } from "react-i18next";
import { Button } from "@/core/shared/v2/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/core/shared/v2/ui/dialog";
import type { BloodTestPackage } from "../../../models";
import { BloodTestsList } from "../blood-tests-list";

type ReadMoreModalProps = {
  bloodTestPackage: BloodTestPackage;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onAddToCart?: () => void;
  isProductInCart?: boolean;
  buttonLabel?: string;
};

export const ReadMoreModal = ({
  bloodTestPackage,
  open,
  onOpenChange,
  onAddToCart,
  isProductInCart = false,
  buttonLabel,
}: ReadMoreModalProps) => {
  const { t } = useTranslation();

  const handleAddToCart = () => {
    onAddToCart?.();
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[640px]">
        <DialogHeader>
          <DialogTitle>{bloodTestPackage.name}</DialogTitle>
        </DialogHeader>
        {bloodTestPackage.description && (
          <p className="whitespace-pre-line text-grey-700 text-sm">{bloodTestPackage.description}</p>
        )}
        <div>
          <h4 className="mb-1 font-bold text-base">{t("GROUP_ACTIONS_ORDERING.BLOOD_TEST_PACKAGE.INCLUDED_TESTS")}:</h4>
          <BloodTestsList bloodTests={bloodTestPackage.bloodTests} />
        </div>
        <div className="flex items-center justify-between gap-4 border-grey-200 border-t pt-4">
          <span className="font-bold text-lg">{formatPrice(bloodTestPackage.grossPrice)}</span>
          {onAddToCart && !isProductInCart && (
            <Button variant="primary" size="lg" disabled={!bloodTestPackage.limitAvailable} onClick={handleAddToCart}>
              {buttonLabel || t("GROUP_ACTIONS_ORDERING.BLOOD_TEST_PACKAGE.SELECT_PACKAGE")}
            </Button>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
